import { createSlice } from '@reduxjs/toolkit';
import { fetchSummarizedChatDownloadFile } from 'store/thunks/segmenterThunks';

const initialState = {
  chatHistories: undefined,
  isChatRefreshed: false,
  chatScrollPositions: {},
  isChatDownloading: false,
  error: null,
};

const segmenterChatSlice = createSlice({
  name: 'segmenterChat',
  initialState,
  reducers: {
    resetChatRefreshFlag(state) {
      state.isChatRefreshed = false;
    },
    setChatHistories(state, action) {
      state.chatHistories = action.payload;
      state.isChatRefreshed = true;
    },
    setChatScrollPositions(state, action) {
      state.chatScrollPositions = action.payload;
    },
    resetChatHistories(state) {
      state.chatHistories = undefined;
      state.isChatRefreshed = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchSummarizedChatDownloadFile.pending, (state) => {
        state.isChatDownloading = true;
        state.error = null;
      })
      .addCase(fetchSummarizedChatDownloadFile.fulfilled, (state, action) => {
        state.isChatDownloading = false;
      })
      .addCase(fetchSummarizedChatDownloadFile.rejected, (state, action) => {
        state.isChatDownloading = false;
        state.error = action.payload;
      });
  },
});

export const { resetChatRefreshFlag, setChatHistories, setChatScrollPositions, resetChatHistories } = segmenterChatSlice.actions;
export default segmenterChatSlice.reducer; 